import { get } from 'lodash';
import * as operators from '@elliemae/ds-utilities/operators';
import { QB_GROUP_CONDITION_TYPES } from './types.js';

var resolveCondition = function resolveCondition(condition, state) {
  var resolveBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QB_GROUP_CONDITION_TYPES.AND;
  if (condition.length === 0 || !condition) return true; // resolve by AND: all the conditions must be true

  if (resolveBy) {
    return condition.every(function (rule) {
      var sourceRule = rule.source,
          operatorRule = rule.operator,
          valueRule = rule.value;
      return operators[operatorRule](get(state, sourceRule), valueRule);
    });
  } // resolve by OR: at least one condition must be true


  return condition.some(function (rule) {
    var sourceRule = rule.source,
        operatorRule = rule.operator,
        valueRule = rule.value;
    return operators[operatorRule](state[sourceRule], valueRule);
  });
};

var resolveDependencies = function resolveDependencies(state, fields) {
  var fieldsToRender = fields.reduce(function (result, _ref) {
    var target = _ref.target,
        component = _ref.component,
        condition = _ref.condition,
        resolveBy = _ref.resolveBy;
    if (resolveCondition(condition, state, resolveBy)) result.push({
      target: target,
      component: component
    });
    return result;
  }, []);
  return fieldsToRender;
};

export { resolveDependencies };
//# sourceMappingURL=dependencies.js.map
